import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Form,
  Typography,
  VertButton,
  VertContainer,
  VertInput,
  VertModal,
  notification,
} from '@vertem-core/vertice-ds';
import { Col, Row } from 'antd';
import * as yup from 'yup';

const ModalCancel = ({ isVisible, submitCancel, setIsVisible }) => {
  const [form] = Form.useForm();

  const schema = yup.object().shape({
    description: yup.string().required('Comentário é obrigatório'),
  });

  const yupSync = {
    async validator({ field }, value) {
      await schema.validateSyncAt(field, { [field]: value });
    },
  };

  return (
    <VertModal
      title="Recusar Solicitação"
      open={isVisible}
      onCancel={() => setIsVisible(false)}
      footer={
        <Row justify="space-between">
          <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}>
            <VertButton
              className="button-view-redemption"
              onClick={() => setIsVisible(false)}
            >
              CANCELAR
            </VertButton>
          </Col>

          <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}>
            <Button
              type="primary"
              danger
              className="button-view-redemption-danger"
              htmlType="submit"
              form="form-cancel-spot"
            >
              SIM
            </Button>
          </Col>
        </Row>
      }
    >
      <VertContainer>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography.Text>
            Certeza que deseja{' '}
            <Typography.Text strong> recusar</Typography.Text> essa solicitação?
          </Typography.Text>
          <Typography.Text>
            Ao clicar em sim, você recusará o orçamento proposto.
          </Typography.Text>

          <Form
            style={{
              marginBottom: '20px',
              marginTop: '20px',
              width: '100%',
            }}
            form={form}
            scrollToFirstError
            name="basic"
            initialValues={{ remember: true }}
            autoComplete="off"
            id="form-cancel-spot"
            onFinish={(values) => {
              submitCancel(values);
            }}
          >
            <Form.Item
              name="description"
              rules={[yupSync]}
              validateTrigger="onBlur"
            >
              <VertInput.TextArea
                className="modal-text-area"
                placeholder="* Deixe seu comentário"
              />
            </Form.Item>
          </Form>
        </div>
      </VertContainer>
    </VertModal>
  );
};

ModalCancel.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  submitCancel: PropTypes.func.isRequired,
};

export default ModalCancel;
